import { API_HEX_COLOR_3_TO_6 } from "@timeghost/shared";

export type {
	Project as SettingsProject,
	ProjectAdd,
	ProjectBudgetType,
	ProjectClient as SettingsProjectClient,
	ProjectGroup as SettingsProjectGroup,
	ProjectMemberRole,
	ProjectTag as SettingsProjectTag,
	ProjectTimesRecorded as SettingsProjectTimesRecorded,
	ProjectUpdate,
	ProjectUser as SettingsProjectUser,
	WhoCanAddTasks,
} from "@timeghost/web-api";
export {
	parseProject as toSettingsProject,
	projectBudgetType,
	projectRecordedSeconds,
	resolveWhoCanAddTasks,
	WHO_CAN_ADD_TASKS_EVERYONE,
	WHO_CAN_ADD_TASKS_PM_ONLY,
	WHO_CAN_ADD_TASKS_PROJECT_TEAM,
} from "@timeghost/web-api";

export const isValidProjectHex = (value: string): boolean => API_HEX_COLOR_3_TO_6.test(value.trim());

export const DEFAULT_PROJECT_COLOR = "#4c85d6";

/** First valid hex among candidates (catalog before embed). */
export const resolveProjectHex = (...candidates: readonly (string | null | undefined)[]): string | null => {
	for (const candidate of candidates) {
		if (candidate && isValidProjectHex(candidate)) {
			return candidate.trim();
		}
	}
	return null;
};

type ProjectColorSource = {
	readonly color?: string | null;
	readonly useAsDefault?: boolean;
} | null;

/** Chip / list color: prefers live catalog, hides default projects. */
export const resolveProjectDisplayColor = (
	project: ProjectColorSource | undefined,
	catalog?: ProjectColorSource
): string | null => {
	if (!project) {
		return null;
	}
	if (catalog?.useAsDefault === true || project.useAsDefault === true) {
		return null;
	}
	return resolveProjectHex(catalog?.color, project.color);
};

export const isTemplateProject = (project: { readonly projectType: "project" | "template" }): boolean =>
	project.projectType === "template";

export const colorFromClient = (
	client: {
		readonly color: string | null;
		readonly useAsDefault?: boolean;
	} | null
): string => {
	if (!client || client.useAsDefault) {
		return DEFAULT_PROJECT_COLOR;
	}
	if (client.color && isValidProjectHex(client.color)) {
		return client.color;
	}
	return DEFAULT_PROJECT_COLOR;
};

export const newProjectBillableFromWorkspace = (
	workspace: {
		readonly raw: Record<string, unknown>;
	} | null
): boolean => {
	const settings = workspace?.raw.settings;
	if (!settings || typeof settings !== "object") {
		return true;
	}
	return (settings as Record<string, unknown>).isNewProjectBillable !== false;
};
